import { Component, ViewChild } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import Contact from '../../../../../../core/data/models/contact.model';

@Component({
    selector: 'app-contact-modal',
    imports: [],
    templateUrl: './contact-modal.component.html',
    styleUrl: './contact-modal.component.css'
})
export class ContactModalComponent {
  @ViewChild('modal') modal!: NgbModalRef

  contact: Contact = {} as any
  emergencyContact?: Contact = {} as any

  constructor(private modalService: NgbModal){}

  show(contact: Contact, emergencyContact?: Contact){
    this.contact = contact;
    this.emergencyContact = emergencyContact;
    this.modalService.open(this.modal, { size: 'lg'})
  }


}
